<div class="row UNFAPP-lvcls-mob-rw-scrll UNFAPP-enroll-wrp-inergap">
    <ng-container *ngFor="let item of carouselData?.data; index as i">
        <ng-container *ngIf="i <= 2">
            <div class="col-lg-4 col-md-8 col-11" *ngIf="carouselData?.dataModel == 'class'">
              <app-class-card  *ngIf="carouselData?.dataModel == 'class'" [dataType]="carouselData?.dataType" [classData]="item" [index]="i"></app-class-card>
            </div>
            <!-- <div class="col-6" *ngIf="carouselData?.dataModel == 'courseTutor'">
              <app-course-tutor-card *ngIf="carouselData?.dataModel == 'courseTutor'" [teacherData]="item" [dataType]="carouselData?.dataType" ></app-course-tutor-card>
            </div> -->
        </ng-container>
        <ng-container *ngIf="i <= 1">
          <div class="col-md-6 col-12" *ngIf="carouselData?.dataModel == 'courseTutor'">
            <app-course-tutor-card *ngIf="carouselData?.dataModel == 'courseTutor'" [teacherData]="item" [dataType]="carouselData?.dataType" ></app-course-tutor-card>
          </div>
        </ng-container>
        <ng-container *ngIf="i <= 1">
          <div class="col-lg-6 col-md-8 col-11" *ngIf="carouselData?.dataModel == 'course'">
            <app-course-card *ngIf="carouselData?.dataModel == 'course'" [courseData]="item" [fromLiveClassPage]="fromLiveClassPage" [dataType]="carouselData?.dataType" ></app-course-card>
          </div>
        </ng-container>
    </ng-container>
</div>
<ng-container *ngIf="carouselData?.dataModel == 'courseBatch'">
  <ng-container *ngFor="let item of carouselData?.data; index as i">
    <app-course-batch-card *ngIf="carouselData?.dataModel == 'courseBatch'" [batchData]="item" [dataType]="carouselData?.dataType" ></app-course-batch-card>
  </ng-container>
</ng-container>
<!-- <ng-container *ngFor="let item of carouselData?.data; index as i">
</ng-container> -->


